import { useState } from 'react';
import { FilterOption } from '../../utils/const';

interface FilterButtonsProps {
  filters: FilterOption[];
  onChange?: (selectedFilters: FilterOption[]) => void;
}

export const FilterButtons = ({ filters, onChange }: FilterButtonsProps) => {
  const [selectedFilters, setSelectedFilters] = useState<FilterOption[]>([
    FilterOption.ALL,
  ]);

  const handleFilterClick = (filter: FilterOption) => {
    let newFilters: FilterOption[];

    if (filter === FilterOption.ALL) {
      newFilters = [FilterOption.ALL];
    } else {
      const updatedFilters = selectedFilters.includes(filter)
        ? selectedFilters.filter(f => f !== filter)
        : [...selectedFilters.filter(f => f !== FilterOption.ALL), filter];

      newFilters =
        updatedFilters.length === 0 ? [FilterOption.ALL] : updatedFilters;
    }

    setSelectedFilters(newFilters);
    onChange?.(newFilters);
  };

  return (
    <div className="flex gap-4">
      {filters.map(filter => (
        <button
          key={filter}
          onClick={() => handleFilterClick(filter)}
          className={`px-4 py-2 rounded-full text-small transition-colors ${
            selectedFilters.includes(filter)
              ? 'border border-main bg-select text-mainDark'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200 border border-border'
          }`}
        >
          {filter}
        </button>
      ))}
    </div>
  );
};
